<template>
  <div
    id="app"
    class="oo-module testing"
    :style="getStyle()"
    :class="isRolldStore() ? 'rolld-normal-font' : ''"
  >
    <div v-if="!showProgress">
      <rolld-navigation-bar
        v-if="isRolldStore() && !isMobile()"
      ></rolld-navigation-bar>
      <component :is="layout">
        <transition v-if="showNewUi" :name="this.transitionName">
          <router-view />
        </transition>
        <router-view v-else />
        <div id="recaptcha-container"></div>
      </component>
    </div>
    <div v-if="showProgress">
<!--      <transition name="fade">-->
        <progress-indicator />
<!--      </transition>-->
    </div>
    <alert-modal></alert-modal>
    <paylater-alert
      v-if="!showProgress && this.$route.name == 'store'"
    ></paylater-alert>
  </div>
</template>

<style lang="scss">
@keyframes show {
  0% {
    transform: translateY(100px);
  }
  60% {
    transform: translateY(-80px);
  }
  100% {
    transform: translateY(0px);
  }
}
.router-view-c {
  //position: absolute;
  transition: opacity 0.5s, transform 0.5s;
  width: 100%;
}
.forward-enter,
.back-leave-active {
  opacity: 0.5;
  transform: translateX(100%);
}
.forward-leave-active,
.back-enter {
  opacity: 0.5;
  transform: translateX(-100%);
}
</style>

<script>
const default_layout = "full";
import { mapGetters, mapMutations, mapActions } from "vuex";
import ProgressIndicator from "./components/progressindicator";
import rolldNavigationBar from "./components/rolldNavigationBar";
import en from "vee-validate/dist/locale/en";
import zh_CN from "vee-validate/dist/locale/zh_CN";
import { Validator } from "vee-validate";
import store from "../src/store";
import AlertModal from "./components/AlertModal.vue";
import { decodeHtml } from "./api/helpers/stringHelper";
import paylaterAlert from "./components/shared/paylaterAlert.vue";
import { auth } from "./server";
import firebase from "firebase/compat/app";
import EventBus from "./event-bus";
import { normalizeQueryParams } from "./api/helpers/uiHelper";

export default {
  components: {
    ProgressIndicator,
    rolldNavigationBar,
    AlertModal,
    paylaterAlert,
  },
  created() {
    this.initHQDoc();

    this.setStoreLoading();
    this.setActivePopupState(false);
    this.setCurrentStoreDoc();
    let langStr = null;
    if (typeof store.getters.selectedLocale === "object") {
      langStr = store.getters.selectedLocale.locale;
    } else langStr = store.getters.selectedLocale;
    langStr = langStr.replace("-", "_");
    Validator.localize(langStr, langStr == "en" ? en : zh_CN);
  },
  data() {
    return {
      transitionName: "slide-right",
      loading: false,
      isTagSet: false,
    };
  },
  computed: {
    ...mapGetters(["viewConfig"]),
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },
    showNewUi() {
      return this.viewConfig.IsNewUi && this.isMobile();
    },
    showProgress() {
      return (
        (!this.getloadedMenu || !this.currentStoreDoc || this.loading) &&
        [
          "mainpage",
          "registerSoUser",
          "registerSoUserNew",
          "completeorder",
          "finalizeSoRegisteration",
          "loginSoUser",
          "slug",
          "notFoundPage",
        ].includes(this.$route.name) === false
      );
    },
    ...mapGetters([
      "storeLoaded",
      "desktopStyles",
      "activePopup",
      "selectedCompany",
      "hqDoc",
      "getloadedMenu",
      "currentStoreDoc",
    ]),
  },
  watch: {
    $route(to, from) {
      if (!this.showNewUi) return;
      // //Todo make it on show new ui
      const toDepth = to.meta.depth || 0;
      const fromDepth = from.meta.depth || 0;
      const animation = toDepth > fromDepth ? "slide-left" : "slide-right";
      this.transitionName = to.meta.animation || animation;
    },
    currentStoreDoc: {
      handler(newVal) {
        if (newVal && newVal.Logo) {
          this.setFavicon(newVal.Logo);
        }
      },
      immediate: true, // Run the watcher immediately after mounting
    },
  },
  mounted() {
    this.initApp();
    this.initServerTime();
    this.setSurchargeTime(null);

    // Set favicon manually
    // Attempt to set favicon initially, if currentStoreDoc is available
    if (this.currentStoreDoc && this.currentStoreDoc.Logo) {
      this.setFavicon(this.currentStoreDoc.Logo);
    }


    let langStr = store.getters.selectedLocale;
    langStr = langStr.replace("-", "_");
    Validator.localize(langStr, langStr == "en" ? en : zh_CN);
    document.body.style.backgroundColor = this.isRolldStore()
      ? "#FFFBF2"
      : "transparent";
    this.scrollFix();
    EventBus.$on('update-script', (payload) => {
      if (!this.isTagSet) {
        if (payload.hq) {
          // check if hq matches with storeData
          if (payload.hq.ID !== payload.store.HQCompanyID) {
            return;
          }
        }
        const EmbeddedScriptHQ = payload.hq ? payload.hq.EmbeddedScript : null;
        const { EmbeddedScript } = payload.store;
        if (EmbeddedScriptHQ) {
          this.appendGoogleTag(EmbeddedScriptHQ);
        } else if (EmbeddedScript) {
          this.appendGoogleTag(EmbeddedScript);
        }
        this.isTagSet = true;
      }
    });
  },
  methods: {
    ...mapActions([
      "initHQDoc",
      "initStore",
      "getStoreMenu",
      "initPayTable",
      "getTableOrder",
      "setPeople",
      "updateUserPoints",
      "setUser",
      "getGiftCardMenu",
    ]),
    ...mapMutations([
      "setStoreLoading",
      "setCurrentStoreDoc",
      "setActivePopupState",
      "setSurchargeTime",
    ]),

    setFavicon(faviconUrl) {
      const uniqueUrl = `${faviconUrl}?v=${new Date().getTime()}`;

      // Remove any existing favicon
      let existingLink = document.querySelector("link[rel~='icon']");
      if (existingLink) {
        existingLink.remove();
      }

      // Create and set the new favicon
      const newLink = document.createElement("link");
      newLink.rel = "icon";
      newLink.href = uniqueUrl;
      document.head.appendChild(newLink);

      // Safari workaround: Temporarily switch rel attribute
      setTimeout(() => {
        newLink.rel = "shortcut icon";
        newLink.rel = "icon";
      }, 100);
    },

    getStyle() {
      var style = [];
      if (!this.isMobile()) {
        style.push(this.desktopStyles.primaryBodyBackground);
      }
      style.push(this.desktopStyles.textColour);
      if (this.showNewUi) {
        style.push({
          "font-family": '"Open Sans", sans-serif',
        });
      }
      return style;
    },
    scrollFix() {
      document.body.onwheel = () => {
        if (!this.activePopup) {
          document.body.classList.remove("modal-open");
          if (document.body.style.overflow === "hidden") {
            document.body.style.overflow = "";
          }
        }
      };
    },
    appendGoogleTag(tagContent) {
      let value = decodeHtml(tagContent);
      // find sources
      let srcRegEx = /src="(.*?)"/g;
      let source = srcRegEx.exec(value);
      if (source && source.length > 1) {
        let srcScript = document.createElement("script");
        srcScript.src = source[1];
        srcScript.async = true;
        document.head.append(srcScript);
      }

      // find scripts
      value = value.replace('<br />', '');
      let re = /<(script|noscript)>([\s\S]*?)<\/(script|noscript)>/g;
      let matches = re.exec(value);
      const htmlContent = matches[2].replace('<br />', '');
      let content = document.createTextNode(htmlContent);
      let comment = document.createTextNode("// Google Tag Manager");
      if (matches[1] === "noscript") {
        const noscript = document.createElement("noscript");
        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = htmlContent;
        const iframeElement = tempContainer.firstChild;
        const comment = document.createComment(" Google Tag Manager ");
        noscript.appendChild(comment);
        noscript.appendChild(iframeElement);
        const bodyElement = document.body;
        bodyElement.insertBefore(noscript, bodyElement.firstChild);
      } else {
        let script = document.createElement("script");
        script.appendChild(comment);
        script.appendChild(content);
        document.head.append(script);
      }
    },
    initApp() {
      const guestCount = normalizeQueryParams(this.$route.query)['guestcount'];
      if (guestCount) {
        this.setPeople(Number(guestCount));
      }
      const isGiftCardPage = this.$route.path.includes("giftcards");
      // do not set this for giftcard landing page and check
      const storeId = this.$route.params.storeid || this.$route.params.storeId;
      if (storeId) {
        this.initStore({
          storeId: storeId,
          callback: () => {
            this.loading = false;
            this.customTokenLogin();
          },
        });
        if (isGiftCardPage) {
          this.getGiftCardMenu(storeId);
          return;
        }
        this.getStoreMenu(storeId);
        this.initPayTable(storeId);
      }
    },
    customTokenLogin() {
      const ct = this.$route.query.t;
      if (ct) {
        if (auth) {
          auth
            .signInWithCustomToken(ct)
            .then((res) => {
              this.setUser({
                Email: res.user.email,
                Mobile: res.user.phoneNumber,
                HQCompanyID: this.currentStoreDoc.HQCompanyID,
              });
              this.updateUserPoints();
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    async initServerTime() {
      try {
        if (window.serverTimeRef) {
          clearInterval(window.serverTimeRef);
        }
        window.serverTimeRef = setInterval(async () => {
          const result = await firebase
            .database()
            .ref("/.info/serverTimeOffset")
            .once("value");

          window.serverTime = new Date(result.val() + Date.now());
        }, 5000);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
